import { render, staticRenderFns } from "./orderpercentage.vue?vue&type=template&id=32b8d1ac&scoped=true"
import script from "./orderpercentage.vue?vue&type=script&lang=js"
export * from "./orderpercentage.vue?vue&type=script&lang=js"
import style0 from "./orderpercentage.vue?vue&type=style&index=0&id=32b8d1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8d1ac",
  null
  
)

export default component.exports